export enum OrdersApiMethods {
    getOrders = 'Orders.GetOrders',
    getOrder = 'Orders.GetOrder',
    ordersCancelOrderPayment = "Orders.CancelOrderPayment",
}
